<ng-container [formGroup]="form">
    <h5>{{ entity?.longName }}</h5>
    <div class="form-row">
        <div class="form-group col-lg-4">
            <app-dc-select
                [labelId]="'obligationCategory'"
                [label]="labels.creditProvision.obligationCategory"
                [items]="obligationCategoryItems"
                closeOnSelect="true"
                formControlName="obligationCategory"
                [clearSelection]="true"
            ></app-dc-select>
        </div>
        <div class="form-group col-lg-4">
            <app-dc-select
                [labelId]="'valuationObligationCategory'"
                [label]="labels.creditProvision.valuationObligationCategory"
                [items]="valuationObligationCategoryItems"
                closeOnSelect="true"
                formControlName="valuationObligationCategory"
                [clearSelection]="true"
            ></app-dc-select>
        </div>
    </div>

    <div class="form-row">
        <div class="form-group col-lg-4">
            <app-dc-select
                [labelId]="'obligationCharacteristics'"
                [label]="labels.creditProvision.obligationCharacteristics"
                [items]="obligationCharacteristicsItems"
                closeOnSelect="true"
                formControlName="obligationCharacteristics"
                [clearSelection]="true"
                [multiple]="true"
                [checkbox]="true"
            ></app-dc-select>
        </div>
        <div class="form-group col-lg-4">
            <app-dc-select
                [labelId]="'valuationObligationCharacteristics'"
                [label]="labels.creditProvision.valuationObligationCharacteristics"
                [items]="valuationObligationCharacteristicsItems"
                closeOnSelect="true"
                formControlName="valuationObligationCharacteristics"
                [clearSelection]="true"
                [multiple]="true"
                [checkbox]="true"
            ></app-dc-select>
        </div>
        <div class="form-group col-lg-2">
            <app-dc-select
                [labelId]="'specifiedDomesticCurrency'"
                [label]="labels.creditProvision.obligationSpecifiedCurrency"
                [items]="currencies"
                closeOnSelect="true"
                formControlName="specifiedDomesticCurrency"
                [clearSelection]="true"
            ></app-dc-select>
        </div>
        <div class="form-group col-lg-2">
            <app-dc-select
                [labelId]="'domesticCurrency'"
                [label]="labels.creditProvision.obligationDomesticCurrency"
                [items]="currencies"
                closeOnSelect="true"
                formControlName="domesticCurrency"
                [clearSelection]="true"
            ></app-dc-select>
        </div>
    </div>
</ng-container>